module.exports = __webpack_public_path__ + "img/amor-face-1.54784c66.jpg";